// components/Captcha.tsx
"use client";

// Dependencies
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

export default function Captcha({
  onChange,
  expireCallback,
}: {
  onChange: (token: string) => void;
  expireCallback?: () => void;
}) {
  const captchaRef = useRef<HTMLDivElement>(null);
  const renderedCaptchaId = useRef<number | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        captchaRef.current &&
        window.grecaptcha &&
        renderedCaptchaId.current === null
      ) {
        renderedCaptchaId.current = window.grecaptcha.render(
          captchaRef.current,
          {
            sitekey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
            callback: onChange,
            "expired-callback": expireCallback,
          }
        );
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [onChange, expireCallback]);

  return <div ref={captchaRef}></div>;
}
